export const authTokenService = {
    saveToken: (token,userName) => saveToken(token,userName),
    clearToken: () => clearToken(),
    getToken: () => getToken(),
    getClaims: () => getClaims(),
    setActiveSurveyId: (surveyId) => setActiveSurveyId(surveyId),
    getActiveSurveyId: (surveyId) => getActiveSurveyId(surveyId),
    isAdmin: () => isAdmin(),
    setFYVolume: (FYVolume) => setFYVolume(FYVolume),
    getFYVolume: () => getFYVolume(),
    setCurrentVolume: (cVolume) => setCurrentVolume(cVolume),
    getCurrentVolume: () => getCurrentVolume(),
    setNotaAdmin: (notaAdmin) => setNotaAdmin(notaAdmin),
    getNotaAdmin: () => getNotaAdmin(),
};

/**
 * Saves the auth token locally.
 * @param {string} token - The auth token to be stored.
 */
function saveToken (token,userName) {
    localStorage.setItem('access_token', token);
    localStorage.setItem('userName', userName);
}

/**
 * Clears the token from local storage.
 */
function clearToken () {
    localStorage.removeItem('access_token');
    localStorage.removeItem('surveyId');
    localStorage.removeItem('userName');
    localStorage.removeItem('cVolume');
    localStorage.removeItem('FYVolume');
    localStorage.removeItem('notaAdmin');
}

/**
 * Gets the token from local storage.
 */
function getToken () {
    return localStorage.getItem('access_token');
}

function setActiveSurveyId (surveyId) {
    localStorage.setItem('surveyId', surveyId);
}

function getActiveSurveyId (surveyId) {
    return localStorage.getItem('surveyId');
}

function setFYVolume (FYVolume)
{
    return localStorage.setItem('FYVolume',FYVolume);
}

function getFYVolume () {
    return localStorage.getItem('FYVolume');
}

function setCurrentVolume (cVolume)
{
    return localStorage.setItem('cVolume',cVolume);
}

function getCurrentVolume () {
    return localStorage.getItem('cVolume');
}

function setNotaAdmin (notaAdmin)
{
    return localStorage.setItem('notaAdmin',notaAdmin);
}

function getNotaAdmin () {
    return localStorage.getItem('notaAdmin');
}

/**
 * Returns the JWT claims
 */
function getClaims () {
    const token = getToken();
    if (token) {
        return JSON.parse(atob(token.split('.')[1])); // TODO - DD - Store this so we don't have to parse every time...
    }
    return {};
}

/**
 * Returns whether or not the user has the 'Admin' role
 */
function isAdmin () {
    // TODO - DD - look into caching this info
    let claims = getClaims();
    if (claims.role && claims.role.length > 0) {
        return (claims.role.indexOf('Admin') !== -1);
    }
}
